import { Image, useTheme } from "@aws-amplify/ui-react";

export function Header() {
  const { tokens } = useTheme();

  return (
    <div style={{ display: "inline-flex", padding: "2rem" }}>
      <Image
        alt="logo"
        src={require("assets/img/Logo_Mirth.svg").default}
        className="mr-3"
      />
      <Image
        alt="logo"
        style={{ width: "335px" }}
        src={require("assets/img/MCC_Logo_Text.svg").default}
      />
    </div>
  );
}
